import { request } from './http';

export async function getStandardsAndRegulations(filters = {}) {
    const queryParams = new URLSearchParams();
    if (filters.GoverningBodyIDs && filters.GoverningBodyIDs.length > 0) {
      queryParams.append('GoverningBodyIDs', filters.GoverningBodyIDs.join(','));
    } else if (filters.GoverningBodyID != null && filters.GoverningBodyID !== '') {
      queryParams.append('GoverningBodyID', filters.GoverningBodyID);
    }
    if (filters.ComplianceAspectIDs && filters.ComplianceAspectIDs.length > 0) {
      queryParams.append('ComplianceAspectIDs', filters.ComplianceAspectIDs.join(','));
    } else if (filters.ComplianceAspectID != null && filters.ComplianceAspectID !== '') {
      queryParams.append('ComplianceAspectID', filters.ComplianceAspectID);
    }
    const queryString = queryParams.toString();
    return request(`/standards-and-regulations${queryString ? '?' + queryString : ''}`);
  }

export async function getStandardsAndRegulationsByTags(tagIds) {
    // Legacy: tags removed; return all regulations (filter client-side if needed)
    return getStandardsAndRegulations({});
  }

export async function getStandardsAndRegulation(id) {
    return request(`/standards-and-regulations/${id}`);
  }

export async function createStandardsAndRegulation(regulationData) {
    return request('/standards-and-regulations', {
      method: 'POST',
      body: JSON.stringify(regulationData),
    });
  }

export async function updateStandardsAndRegulation(id, regulationData) {
    return request(`/standards-and-regulations/${id}`, {
      method: 'PUT',
      body: JSON.stringify(regulationData),
    });
  }

export async function deleteStandardsAndRegulation(id) {
    return request(`/standards-and-regulations/${id}`, {
      method: 'DELETE',
    });
  }

export async function updateApplicabilityReview(id, reviewData) {
    return request(`/verifications/applicability-reviews/${id}`, {
      method: 'PUT',
      body: JSON.stringify(reviewData),
    });
  }

export async function bulkUpdateApplicabilityReviews(updates) {
    return request('/verifications/applicability-reviews/bulk', {
      method: 'PUT',
      body: JSON.stringify({ updates }),
    });
  }

export const standardsAndRegulationsApi = {
  getStandardsAndRegulations,
  getStandardsAndRegulationsByTags,
  getStandardsAndRegulation,
  createStandardsAndRegulation,
  updateStandardsAndRegulation,
  deleteStandardsAndRegulation,
  updateApplicabilityReview,
  bulkUpdateApplicabilityReviews,
};

